import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from "../context/AuthContext"; 
import { apiRequest } from "../utils/api";
import "../styles/BuyPrintPreview.css";

const PrintPreview = () => {
  const location = useLocation();
  const { user: userInfo, loading } = useAuthContext(); // Contextから取得
  const [storeId, setStoreId] = useState("");
  const navigate = useNavigate();
  const { id } = location.state || {};
  const [item, setItem] = useState(null);

  useEffect(() => {
    if (userInfo?.store_id) {
      setStoreId(userInfo.store_id);
    }
  }, [userInfo]);

  useEffect(() => {
    const fetchItem = async () => {
      if (!id) return;

      try {
        const response = await apiRequest(`inventory/inventory/${id}/`, "GET");
        console.log("商品", response);
        setItem(response); // 必要なら状態にセット
      } catch (error) {
        console.error("商品取得エラー:", error);
      }
    };

    fetchItem();
  }, [id]);

    useEffect(() => {
      // ページがロードされたときに自動で印刷プレビューを表示
      const timeoutId = setTimeout(() => {
        window.print(); // 少し遅らせてから呼び出す
      }, 500);

      // 印刷完了後に前のページに戻る処理
      const handleAfterPrint = () => {
        navigate(-1);  // 一つ前のページに戻る
      };

      window.onafterprint = handleAfterPrint;

      // クリーンアップ
      return () => {
        clearTimeout(timeoutId);  // setTimeoutのクリア
        window.onafterprint = null;  // イベントハンドラの解除
      };
    }, [navigate]);


  if (loading || !item) return <div>読み込み中...</div>;
  return (
    <div>
      <div className="buy-print">
        <div className="buy-printtop">
        <div className="buy-printmoji1">{item.manufacturer}</div>
        <div className={`${(() => {
          const inv = item.store_inventory_set?.find(inv => inv.store === storeId);

          if (!inv) return ''; // データなしの場合はクラスを追加しない

          // buy_specialprice_switch に応じてクラスを動的に追加
          return inv.buy_specialprice_switch ? 'buy-printpic' : 'buy-printpicN';
        })()}`}>
          <img src={`/media/product_images/${item.sku}.jpg`} alt="商品画像"/>
          <div className="buyspecial1">超</div> 
          <div className="buyspecial2">高</div> 
          <div className="buyspecial3">額</div>
          <div className="buyspecial4">買</div>
          <div className="buyspecial5">取</div>
          <div className="buyspecial6">特</div>
          <div className="buyspecial7">別</div>
          <div className="buyspecial8">指</div>
          <div className="buyspecial9">定</div>
        </div>
        <div className="buy-printmoji2">{item.item_name}</div>
        <div className="flex">
        <div className="buy-printsumoji2">買取<br/>上限</div>
        <div className="buy-printsumoji">          
            {(() => {
              const inv = item.store_inventory_set?.find(inv => inv.store === storeId);

              if (!inv) return 'データなし';

              if (inv.buy_specialprice_switch) {
                const formattedPrice = new Intl.NumberFormat().format(inv.buy_specialprice ?? 0);
                return <>{formattedPrice}<span>円</span></>;
              } else {
                const formattedPrice = new Intl.NumberFormat().format(inv.buy_price ?? 0);
                return <>{formattedPrice}<span>円</span></>;
              }
            })()}
          </div></div>
        在庫状況・相場・再販等により予告無く価格が変動する場合が御座います<br/>
        開封品は通常買取価格となります。複数個の場合は個数制限させて頂く場合が御座います。
        </div>
      </div>
    </div>
  );
};

export default PrintPreview;
